export default __webpack_public_path__ + "static/media/moderncv.563cbb92.png";